var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadIcon2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33325 12.1668V13.8335C1.33325 14.2755 1.50885 14.6994 1.82141 15.012C2.13397 15.3246 2.55789 15.5002 2.99992 15.5002H12.9999C13.4419 15.5002 13.8659 15.3246 14.1784 15.012C14.491 14.6994 14.6666 14.2755 14.6666 13.8335V12.1668M3.83325 7.16683L7.99992 11.3335M7.99992 11.3335L12.1666 7.16683M7.99992 11.3335V1.3335",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon2);
export default __webpack_public_path__ + "static/media/download-icon_2.4c8c06e58ce088769fcf61513d9087fc.svg";
export { ForwardRef as ReactComponent };